'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _planLevel = require('./plan-level');

var _planLevel2 = _interopRequireDefault(_planLevel);

var _planLevelEnterprise = require('./plan-level-enterprise');

var _planLevelEnterprise2 = _interopRequireDefault(_planLevelEnterprise);

var _planLevelFree = require('./plan-level-free');

var _planLevelFree2 = _interopRequireDefault(_planLevelFree);

var _toggle = require('common/components/toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlanChoiceArea = function (_React$Component) {
    _inherits(PlanChoiceArea, _React$Component);

    function PlanChoiceArea() {
        _classCallCheck(this, PlanChoiceArea);

        return _possibleConstructorReturn(this, (PlanChoiceArea.__proto__ || Object.getPrototypeOf(PlanChoiceArea)).apply(this, arguments));
    }

    _createClass(PlanChoiceArea, [{
        key: 'render',


        // NOTE:
        // This is currently hardcoded to 3 columns. We may want to consider something
        // dynamic in the future, but this should work for our current needs.
        value: function render() {

            var timeChoices = [{ 'name': 'ANNUAL', 'value': 'Y' }, { 'name': 'MONTHLY', 'value': 'M' }];
            var MonthlyAnnualSwitch = _react2['default'].createElement(
                'div',
                null,
                _react2['default'].createElement(_toggle.Toggle, {
                    choices: timeChoices,
                    initialSelection: 'Y',
                    isEventbrite: false,
                    onSelection: this.props.onTimeToggle
                })
            );

            var period = this.props.timePeriod;
            var choiceFunc = this.props.onPlanChoice;
            var enterpriseSuccessFunc = this.props.onEnterpriseSuccess;
            var levels = this.props.planData.map(function (plan, i) {
                if (plan.is_enterprise === true) {
                    return _react2['default'].createElement(_planLevelEnterprise2['default'], {
                        key: 'plan-' + i,
                        plan: plan,
                        timePeriod: period,
                        onSuccess: enterpriseSuccessFunc,
                        pricingSource: 'chooseSignupPlan' });
                } else {
                    return _react2['default'].createElement(_planLevel2['default'], {
                        key: 'plan-' + i,
                        plan: plan,
                        onPlanChoice: choiceFunc,
                        timePeriod: period });
                }
            });

            return _react2['default'].createElement(
                'div',
                { className: 'm-choose-signup-plan--plan-choice-area row text-center' },
                MonthlyAnnualSwitch,
                _react2['default'].createElement(
                    'div',
                    { className: 'columns large-12' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-choose-signup-plan--paid-pricing-levels row' },
                        levels
                    )
                ),
                _react2['default'].createElement(_planLevelFree2['default'], null)
            );
        }
    }]);

    return PlanChoiceArea;
}(_react2['default'].Component);

PlanChoiceArea.propTypes = {
    planData: _react2['default'].PropTypes.array.isRequired,
    timePeriod: _react2['default'].PropTypes.string,
    onPlanChoice: _react2['default'].PropTypes.func,
    onEnterpriseSuccess: _react2['default'].PropTypes.func,
    onTimeToggle: _react2['default'].PropTypes.func
};
exports['default'] = PlanChoiceArea;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/plan-choice-area.jsx
 ** module id = 1142
 ** module chunks = 0
 **/